import {Base} from "@/api/Base"

export class RemainingGetById extends Base {
    path = "remainingVacation/getById"
}